<template>
  <div v-if="!requestDone">
    <p class="title">
      {{ contest?.title }}
    </p>
    <div class="p-infos u-mb-5">
      <div class="p-infos__detail">{{ contest?.prize }}</div>
      <div class="p-infos__detail">
        {{ remainingDays }} {{ pluralize('jour', remainingDays) }}
        {{ pluralize('restant', remainingDays) }} pour participer
      </div>
    </div>
    <form
      autocomplete="off"
      @submit.prevent="submit"
    >
      <div v-if="!authenticated">
        <div class="p-title u-mb-4">
          <span>1.</span> Inscription We Are PlayStation
        </div>

        <div class="u-d-f u-ai-c u-jc-sb">
          M'inscrire avec
          <span
            class="link"
            @click="openLoginModal"
            >Déjà inscrit(e) ?</span
          >
        </div>
        <hr class="first" />
        <div class="o-row">
          <div class="o-col u-12">
            <button
              class="btn btn-fb"
              @click="registerWithFacebook"
            >
              <img
                src="~/assets/icons/facebook.svg"
                alt="Facebook icon"
              />
              Facebook
            </button>
          </div>
        </div>
        <hr class="first" />
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <select
                id="civility"
                ref="civilityRef"
                v-model="form.civility"
                name="civility"
                class="c-form__select"
                required
                :class="{ 'is-invalid': errors.civility }"
              >
                <option
                  value
                  disabled
                  selected
                >
                  Civilité
                </option>
                <option
                  v-for="gender in referential?.choiceGender"
                  :key="gender.value"
                  :value="gender.value"
                >
                  {{ gender.label }}
                </option>
              </select>
              <span
                v-if="errors.civility"
                class="c-form__feedback is-invalid"
              >
                {{ errors.civility }}
              </span>
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="lastname"
                ref="lastnameRef"
                v-model="form.lastname"
                name="lastname"
                type="text"
                class="c-form__control"
                placeholder="Nom*"
                required
                :class="{ 'is-invalid': errors.lastname }"
              />
              <span
                v-if="errors.lastname"
                class="c-form__feedback is-invalid"
              >
                {{ errors.lastname }}
              </span>
            </div>
          </div>
        </div>
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="firstname"
                ref="firstnameRef"
                v-model="form.firstname"
                name="firstname"
                type="text"
                class="c-form__control"
                placeholder="Prénom*"
                required
                :class="{ 'is-invalid': errors.firstname }"
              />
              <span
                v-if="errors.firstname"
                class="c-form__feedback is-invalid"
              >
                {{ errors.firstname }}
              </span>
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="email"
                ref="emailRef"
                v-model="form.email"
                name="email"
                type="email"
                class="c-form__control"
                placeholder="Adresse e-mail*"
                required
                :class="{ 'is-invalid': errors.email }"
              />
              <span
                v-if="errors.email"
                class="c-form__feedback is-invalid"
              >
                {{ errors.email }}
              </span>
            </div>
          </div>
        </div>
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="password"
                ref="passwordRef"
                v-model="form.password"
                name="password"
                type="password"
                class="c-form__control"
                placeholder="Mot de passe*"
                required
                :class="{
                  'is-invalid': errors.password || errors.password_confirmation,
                }"
              />
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="password_confirmation"
                ref="passwordConfirmationRef"
                v-model="form.password_confirmation"
                name="password_confirmation"
                type="password"
                class="c-form__control"
                placeholder="Confirmer le mot de passe*"
                required
                :class="{
                  'is-invalid': errors.password || errors.password_confirmation,
                }"
              />
            </div>
          </div>
        </div>
        <div
          class="text-small u-mb-3"
          :class="{
            'is-invalid': errors.password || errors.password_confirmation,
          }"
        >
          <span v-if="errors.password">{{ errors.password }} <br /></span>
          <span v-if="errors.password_confirmation">
            {{ errors.password_confirmation }} <br />
          </span>
          8 caractères minimum. Au moins une majuscule et un caractère spécial.
        </div>
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="nickname"
                ref="nicknameRef"
                v-model="form.nickname"
                name="nickname"
                type="text"
                class="c-form__control"
                placeholder="Pseudo*"
                required
                :class="{ 'is-invalid': errors.nickname }"
              />
              <span
                v-if="errors.nickname"
                class="c-form__feedback is-invalid"
              >
                {{ errors.nickname }}
              </span>
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-5">
              <input
                id="psnId"
                ref="psnIdRef"
                v-model="form.psnId"
                name="psnId"
                type="text"
                class="c-form__control"
                placeholder="PSN ID (facultatif)"
                :class="{ 'is-invalid': errors.psnId }"
              />
              <span
                v-if="errors.psnId"
                class="c-form__feedback is-invalid"
              >
                {{ errors.psnId }}
              </span>
            </div>
          </div>
        </div>
        <div class="u-mb-5">
          <p
            ref="birthdayRef"
            class="u-mb-3"
          >
            Votre date de naissance*
          </p>
          <div class="o-row">
            <div class="o-col u-3">
              <div class="c-form__group">
                <select
                  id="day"
                  v-model="form.birthData.day"
                  name="day"
                  class="c-form__select"
                  required
                  :class="{ 'is-invalid': errors.birthday }"
                >
                  <option
                    value
                    disabled
                    selected
                  >
                    JJ
                  </option>
                  <option
                    v-for="day in days"
                    :key="day"
                    :value="day"
                  >
                    {{ day }}
                  </option>
                </select>
              </div>
            </div>
            <div class="o-col u-3">
              <div class="c-form__group">
                <select
                  id="month"
                  v-model="form.birthData.month"
                  name="month"
                  class="c-form__select"
                  required
                  :class="{ 'is-invalid': errors.birthday }"
                >
                  <option
                    value
                    disabled
                    selected
                  >
                    MM
                  </option>
                  <option
                    v-for="month in months"
                    :key="month"
                    :value="month"
                  >
                    {{ month }}
                  </option>
                </select>
              </div>
            </div>
            <div class="o-col u-6">
              <div class="c-form__group">
                <select
                  id="year"
                  v-model="form.birthData.year"
                  name="year"
                  class="c-form__select"
                  required
                  :class="{ 'is-invalid': errors.birthday }"
                >
                  <option
                    value
                    disabled
                    selected
                  >
                    AAAA
                  </option>
                  <option
                    v-for="year in years"
                    :key="year"
                    :value="year"
                  >
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="errors.birthday"
              class="o-col u-12"
            >
              <span class="c-form__feedback is-invalid">
                {{ errors.birthday }}
              </span>
            </div>
          </div>
        </div>
        <div>
          <p class="u-mb-3">Votre code d'inscription</p>
          <div class="c-form__group u-mb-3">
            <input
              id="bonusCode"
              ref="bonusCodeRef"
              v-model="form.bonusCode"
              name="bonusCode"
              type="text"
              class="c-form__control"
              placeholder="Votre code bonus (facultatif)"
              :class="{ 'is-invalid': errors.bonusCode }"
            />
            <span
              v-if="errors.bonusCode"
              class="c-form__feedback is-invalid"
            >
              {{ errors.bonusCode }}
            </span>
          </div>
        </div>
        <hr />
        <div class="u-mb-4">
          <div class="news__group">
            <img
              src="~/assets/icons/news-alt.svg"
              alt="Newsletter icon"
              width="32"
              height="32"
            />
            <span class="news news--alt">
              Évaluez vos chances de gagner des bons d’achat !
            </span>
          </div>
          <div class="c-form__group">
            <div class="c-form__check p-news u-ai-fs">
              <input
                id="wapNewsletter"
                v-model="form.wapNewsletter"
                class="c-form__check-input"
                type="checkbox"
                name="wapNewsletter"
              />
              <label
                class="c-form__check-label"
                for="wapNewsletter"
              >
                J'accepte de recevoir chaque mois des emails m'informant du
                classement sur We Are PlayStation afin d'évaluer mes chances de
                remporter des bons d'achat.
              </label>
            </div>
          </div>
        </div>
        <div class="u-mb-4">
          <div class="news__group">
            <img
              src="~/assets/icons/news.svg"
              alt="News icon"
              width="32"
              height="32"
            />
            <span class="news">
              Soyez au courant de toute l'actualité PlayStation
            </span>
          </div>
          <div class="c-form__group">
            <div class="c-form__check p-news u-ai-fs">
              <input
                id="sonyPlaystationNewsletter"
                v-model="form.sonyPlaystationNewsletter"
                class="c-form__check-input"
                type="checkbox"
                name="sonyPlaystationNewsletter"
              />
              <label
                class="c-form__check-label"
                for="sonyPlaystationNewsletter"
              >
                J'accepte de recevoir des informations et des offres
                personnalisées par e-mail concernant PlayStation® et Sony de la
                part de Sony Interactive Entertainment Europe Limited.
              </label>
            </div>
          </div>
        </div>
        <hr />
        <p class="text-small u-mb-5">* champs obligatoires</p>
        <div class="p-title u-mb-4">
          <span>2.</span> Participation au concours
        </div>
      </div>
      <div v-if="contest?.type?.id === 3">
        <p class="u-mb-3">
          Quelle est la réponse à la question
          <template v-if="!contest.question"> ?</template>
          <template v-else>
            suivante : <br />
            <strong>{{ contest.question }}</strong>
          </template>
        </p>
        <div class="c-form__group u-mb-5">
          <textarea
            id="response"
            ref="responseRef"
            v-model="form.answer"
            name="response"
            cols="30"
            rows="10"
            class="c-form__control"
            placeholder="Votre réponse*"
            required
          />
        </div>
      </div>
      <p class="u-mb-3">
        Nous aurons besoin de votre adresse et numéro de mobile dans le cas où
        vous seriez déclaré vainqueur du concours.
        <br />
        <strong>
          Attention, seuls les résidents français peuvent participer.
        </strong>
      </p>
      <div class="c-form__group u-mb-3">
        <input
          id="address"
          ref="addressRef"
          v-model="form.address"
          name="address"
          type="text"
          class="c-form__control"
          placeholder="Adresse*"
          :class="{ 'is-invalid': errors.address }"
          required
        />
        <span
          v-if="errors.address"
          class="c-form__feedback is-invalid"
        >
          {{ errors.address }}
        </span>
      </div>
      <div class="c-form__group u-mb-3">
        <input
          id="addressAdditional"
          ref="addressAdditionalRef"
          v-model="form.addressAdditional"
          name="addressAdditional"
          type="text"
          class="c-form__control"
          placeholder="Complément d'adresse"
          :class="{ 'is-invalid': errors.addressAdditional }"
        />
        <span
          v-if="errors.addressAdditional"
          class="c-form__feedback is-invalid"
        >
          {{ errors.addressAdditional }}
        </span>
      </div>
      <div class="o-row">
        <div class="o-col u-12 u-6@tb">
          <div class="c-form__group u-mb-3">
            <input
              id="zipCode"
              ref="zipCodeRef"
              v-model="form.zipCode"
              type="text"
              class="c-form__control"
              placeholder="Code postal*"
              :class="{ 'is-invalid': errors.zipCode }"
              required
            />
            <span
              v-if="errors.zipCode"
              class="c-form__feedback is-invalid"
            >
              {{ errors.zipCode }}
            </span>
          </div>
        </div>
        <div class="o-col u-12 u-6@tb">
          <div class="c-form__group u-mb-3">
            <input
              id="city"
              ref="cityRef"
              v-model="form.city"
              name="city"
              type="text"
              class="c-form__control"
              placeholder="Ville*"
              :class="{ 'is-invalid': errors.city }"
              required
            />
            <span
              v-if="errors.city"
              class="c-form__feedback is-invalid"
            >
              {{ errors.city }}
            </span>
          </div>
        </div>
        <div class="o-col u-12 u-6@tb">
          <div class="c-form__group u-mb-3">
            <input
              type="text"
              class="c-form__control"
              value="France"
              disabled
            />
          </div>
        </div>
        <div class="o-col u-12 u-6@tb">
          <div class="c-form__group u-mb-3">
            <input
              id="phone"
              ref="phoneRef"
              v-model="form.phone"
              name="phone"
              type="tel"
              class="c-form__control"
              placeholder="Numéro de mobile*"
              :class="{ 'is-invalid': errors.phone }"
              required
            />
            <span
              v-if="errors.phone"
              class="c-form__feedback is-invalid"
            >
              {{ errors.phone }}
            </span>
          </div>
        </div>
      </div>
      <div class="c-form__group">
        <div class="c-form__check">
          <input
            id="consent"
            v-model="form.validateGameRules"
            class="c-form__check-input"
            type="checkbox"
            name="consent"
            required
          />
          <label
            class="c-form__check-label"
            for="consent"
          >
            J'accepte le
            <NuxtLink
              :to="`/page/${contest?.page_legal.slug}`"
              target="_blank"
              >règlement du jeu</NuxtLink
            >*.
          </label>
        </div>
      </div>
      <hr />
      <template v-if="showNewsletter">
        <div class="news__group">
          <img
            src="~/assets/icons/news.svg"
            alt="News icon"
            width="32"
            height="32"
          />
          <span class="news">
            Soyez au courant de toute l'actualité PlayStation
          </span>
        </div>
        <div class="c-form__group">
          <div class="c-form__check p-news u-ai-fs">
            <input
              id="sonyPlaystationNewsletter"
              v-model="form.sonyPlaystationNewsletter"
              class="c-form__check-input"
              type="checkbox"
              name="sonyPlaystationNewsletter"
            />
            <label
              class="c-form__check-label"
              for="sonyPlaystationNewsletter"
            >
              J'accepte de recevoir des informations et des offres
              personnalisées par e-mail concernant PlayStation® et Sony de la
              part de Sony Interactive Entertainment Europe Limited.
            </label>
          </div>
        </div>
        <hr />
      </template>
      <div class="o-row u-mb-4">
        <div
          v-if="!authenticated"
          class="o-col u-12 u-auto@tb u-mb-3 u-mb-0@tb"
        >
          <RecaptchaCheckbox
            @error="onError()"
            @success="onSuccess()"
            @expired="onExpired()"
          />
          <p
            v-if="errors.recaptcha"
            class="is-invalid"
          >
            {{ errors.recaptcha }}
          </p>
        </div>
        <div class="o-col u-d-f u-ai-fe u-jc-fe">
          <ButtonSimple
            type="submit"
            label="Participer"
            :disabled="loading"
          />
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div v-if="!authenticated">
      <p class="u-mb-4">
        Un email de confirmation d’inscription vient de vous être envoyé.
        Cliquez sur le lien pour valider votre inscription.
        <br />
        <br />
        <strong>Attention, ce lien n’est valide que 48h.</strong>
      </p>
      <div class="p-warning u-mb-4">
        <span>Attention</span>
        <p>
          Pour valider votre participation, vous devez activer votre compte We
          Are PlayStation avant la fin du concours. Vous recevrez alors un email
          confirmant votre participation au concours.
        </p>
        <p>Les gagnants seront contactés prochainement par email.</p>
      </div>
    </div>
    <p
      v-else
      class="u-mb-4"
    >
      Un email de confirmation d’inscription vient de vous être envoyé.
      <br />
      <br />
      <strong>Les gagnants seront contactés prochainement par email.</strong>
    </p>
    <div class="u-d-f u-jc-fe">
      <ButtonSimple
        type="button"
        label="Fermer"
        @click="vfm.closeAll()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { differenceInDays } from 'date-fns'
import { useVfm } from 'vue-final-modal'
import type { ValidationError } from 'yup'
import { contestModal } from '~/modals/contest'

type ErrorKeys = keyof typeof errors.value
type ErrorPath = ErrorKeys | undefined

const route = useRoute()
const vfm = useVfm()
const referentialStore = useReferentialStore()
const { referential } = storeToRefs(referentialStore)

const contestsStore = useContestsStore()
const { contest } = storeToRefs(contestsStore)

const errorsYup = {
  civility: '',
  firstname: '',
  lastname: '',
  email: '',
  nickname: '',
  password: '',
  password_confirmation: '',
  birthday: '',
  psnId: '',
  bonusCode: '',
  address: '',
  addressAdditional: '',
  zipCode: '',
  city: '',
  phone: '',
}

const emit = defineEmits(['openLoginModal'])

const loading = ref(false)
const requestDone = ref(false)
const recaptchaSuccess = ref(false)

const auth = useAuth()
const rawUser = unref(auth.data)
const form = ref({
  // registration
  civility: '',
  firstname: '',
  lastname: '',
  email: '',
  nickname: '',
  password: '',
  password_confirmation: '',
  psnId: '',
  birthData: {
    day: '',
    month: '',
    year: '',
  },
  birthday: '',
  bonusCode: '',
  wapNewsletter: false,
  // contest data
  address: rawUser?.address ?? '',
  addressAdditional: rawUser?.address_additional ?? '',
  zipCode: rawUser?.zip_code ?? '',
  city: rawUser?.city ?? '',
  phone: rawUser?.phone ?? '',
  validateGameRules: false,
  sonyPlaystationNewsletter: rawUser?.sony_playstation_newsletter ?? false,
  answer: '',
})
const errors = ref<Partial<typeof errorsYup & { recaptcha?: string }>>({})

const { authenticated } = useAuthenticated()

const remainingDays = computed(() => {
  return differenceInDays(
    new Date(contest.value?.displayed_ends_at as string),
    new Date(),
  )
})

const showNewsletter = computed(() => {
  return authenticated.value && !auth.data.value?.sony_playstation_newsletter
})

const { gtag } = useGtag()

const submit = async () => {
  if (!authenticated.value) {
    return submitAndRegister()
  }

  loading.value = true

  const formData = {
    address: form.value.address,
    addressAdditional: form.value.addressAdditional,
    zipCode: form.value.zipCode,
    city: form.value.city,
    phone: form.value.phone,
    validateGameRules: form.value.validateGameRules,
    sonyPlaystationNewsletter: showNewsletter.value
      ? form.value.sonyPlaystationNewsletter
      : undefined,
    answer: undefined as undefined | string,
  }

  if (contest.value?.type?.id === 3) {
    formData.answer = form.value.answer
  }

  const { data, error } = await useCustomFetch(
    API.POST__SECURE_CONTEST_USER.replace(
      '$slug',
      route.params.contestName as string,
    ),
    {
      method: 'POST',
      body: formData,
    },
  )

  const rawData = unref(data)
  if (error.value || !rawData) {
    loading.value = false

    return logError(
      'from contest modal',
      'There was a problem posting form: ',
      error,
    )
  }

  contestModal.patchOptions({
    attrs: {
      title: `Merci ${auth.data.value?.firstname}`,
    },
  })

  requestDone.value = true

  gtag('event', 'popupPage', {
    popupName: '/popup/concours/confirmation',
  })

  await contestsStore.fetchContest({
    slug: route.params.contestName as string,
  })

  loading.value = false
}

const civilityRef = ref<HTMLElement | null>(null)
const lastnameRef = ref<HTMLElement | null>(null)
const firstnameRef = ref<HTMLElement | null>(null)
const emailRef = ref<HTMLElement | null>(null)
const passwordRef = ref<HTMLElement | null>(null)
const passwordConfirmationRef = ref<HTMLElement | null>(null)
const nicknameRef = ref<HTMLElement | null>(null)
const psnIdRef = ref<HTMLElement | null>(null)
const birthdayRef = ref<HTMLElement | null>(null)
const bonusCodeRef = ref<HTMLElement | null>(null)
const responseRef = ref<HTMLElement | null>(null)
const addressRef = ref<HTMLElement | null>(null)
const addressAdditionalRef = ref<HTMLElement | null>(null)
const zipCodeRef = ref<HTMLElement | null>(null)
const cityRef = ref<HTMLElement | null>(null)
const phoneRef = ref<HTMLElement | null>(null)
const recaptchaRef = ref<HTMLElement | null>(null)

const refs = {
  civility: civilityRef,
  lastname: lastnameRef,
  firstname: firstnameRef,
  email: emailRef,
  password: passwordRef,
  password_confirmation: passwordConfirmationRef,
  nickname: nicknameRef,
  psnId: psnIdRef,
  birthday: birthdayRef,
  bonusCode: bonusCodeRef,
  response: responseRef,
  address: addressRef,
  addressAdditional: addressAdditionalRef,
  zipCode: zipCodeRef,
  city: cityRef,
  phone: phoneRef,
  recaptcha: recaptchaRef,
}

const submitAndRegister = async () => {
  loading.value = true

  const validations = {
    form: false,
    recaptcha: false,
  }

  // Start form validation
  form.value.birthday = `${form.value.birthData.year}-${form.value.birthData.month}-${form.value.birthData.day}`

  try {
    await registrationFormSchema.validate(form.value, { abortEarly: false })
    errors.value = {
      ...errors,
      ...errorsYup,
    }
    validations.form = true
  } catch (err) {
    const error = err as ValidationError
    loading.value = false
    // Re-init errors
    errors.value = {
      ...errors.value,
      ...errorsYup,
    }

    let path: ErrorPath

    error.inner.forEach((innerError) => {
      const innerErrorPath = innerError.path as ErrorKeys
      if (!path) {
        path = innerErrorPath
      }
      if (innerError.path) {
        errors.value[innerErrorPath] = innerError.message
      }
    })

    if (path) {
      refs[path].value?.scrollIntoView(false)
    }
  }

  if (recaptchaSuccess.value) {
    // Valid the recaptcha before continue
    validations.recaptcha = true
  } else {
    loading.value = false
    errors.value.recaptcha = 'Veuillez valider le captcha'

    return
  }

  if (!validations.form || !validations.recaptcha) {
    loading.value = false

    return
  }

  const rawForm = unref(form)

  const formData = {
    // User data
    email: rawForm.email,
    password: {
      first: rawForm.password,
      second: rawForm.password_confirmation,
    },
    civility: rawForm.civility,
    firstname: rawForm.firstname,
    lastname: rawForm.lastname,
    nickname: rawForm.nickname,
    psnId: rawForm.psnId,
    birthday: rawForm.birthData,
    bonusCode: rawForm.bonusCode,
    wapNewsletter: rawForm.wapNewsletter,
    // Contest data
    address: rawForm.address,
    addressAdditional: rawForm.addressAdditional,
    zipCode: rawForm.zipCode,
    city: rawForm.city,
    phone: rawForm.phone,
    validateGameRules: rawForm.validateGameRules,
    sonyPlaystationNewsletter: rawForm.sonyPlaystationNewsletter,
    answer: '',
  }

  if (contest.value?.type?.id === 3) {
    formData['answer'] = form.value.answer
  }

  const { error } = await useCustomFetch(
    API.POST__SECURE_CONTEST_USER.replace(
      '$slug',
      route.params.contestName as string,
    ),
    {
      method: 'POST',
      body: formData,
    },
  )

  if (error.value) {
    const { data, statusCode } = error.value

    if (statusCode && statusCode >= 400 && statusCode < 500) {
      const { errors: responseErrors } = data
      let path: ErrorPath

      Object.keys(responseErrors).forEach((key) => {
        const errorKey = key as ErrorKeys

        if (!path) {
          path = errorKey
        }
        errors.value[errorKey] = responseErrors[errorKey].join(' ')
      })

      if (path) {
        refs[path]?.value?.scrollIntoView(false)
      }
    }

    loading.value = false

    return
  }

  // store.dispatch('modal/changeTitle', `Merci ${this.form.firstname}`)
  requestDone.value = true

  gtag('event', 'popupPage', {
    popupName: '/popup/concours/confirmation',
  })

  loading.value = false
}

const onError = () => {
  errors.value.recaptcha = 'Veuillez valider le captcha'
}

const onSuccess = () => {
  recaptchaSuccess.value = true
  errors.value.recaptcha = ''
}

const onExpired = () => {
  errors.value.recaptcha = 'Veuillez valider le captcha'
}

const openLoginModal = () => {
  emit('openLoginModal')
}

const registerWithFacebook = async () => {
  loading.value = true
  const { $FB } = useNuxtApp()

  $FB.getLoginStatus((response) => {
    if (response.status === 'connected') {
      // connected
      loginFb()
    } else {
      // not_authorized
      $FB.login(
        (response) => {
          if (response.authResponse) {
            return loginFb()
          }
          loading.value = false
        },
        { scope: 'email' },
      )
    }
  })
}

const loginFb = async () => {
  const { $FB } = useNuxtApp()

  loading.value = true
  try {
    $FB.api(
      '/me?fields',
      { fields: 'id,first_name,last_name,email' },
      (response) => {
        const { first_name: firstname, last_name: lastname, email } = response
        form.value = {
          ...form.value,
          firstname,
          lastname,
          email,
        }
      },
    )
  } catch (err) {
    console.error(err)
    loading.value = false
  }

  loading.value = false
}
</script>

<style lang="scss" scoped>
hr {
  margin: 2.5rem 0;
  border-bottom: 0;
  opacity: 0.15;

  &.first {
    margin: 1.5rem 0;
  }
}

.title {
  margin-bottom: 3rem;
  color: $backgroundBlue;
  font-size: 2rem;
  line-height: 1.35;
}

.link {
  font-size: 1.4rem;
  cursor: pointer;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: $dark;
    transition: background 0.35s ease-in-out;
  }

  &:hover::after {
    background-color: transparent;
  }
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 4.6rem;

  &-fb {
    color: #fff;
    background-color: #1976f2;
    border: 0;
  }

  img,
  svg {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 1rem;
  }
}

.news__group {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
}

.news {
  margin-left: 1rem;
  color: $blue;
  font-family: 'SST Condensed';
  font-size: 1.6rem;
  font-weight: 500;

  &--alt {
    color: $orange;
  }

  .points {
    margin-right: 0.6rem;
    color: $orange;
    font-size: 1.9rem;
    font-weight: 700;

    span {
      font-size: 1.1rem;
      text-transform: uppercase;
    }
  }
}

.text-small {
  font-size: 1.2rem;
}

.is-invalid {
  color: #ea5151;
}

.p-infos {
  display: flex;
  border-top: 0.1rem solid #cbcbcb;
  border-bottom: 0.1rem solid #cbcbcb;

  &__detail {
    padding: 2rem 0;
    font-family: 'SST Condensed';
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1.33;
    text-transform: uppercase;

    @media (min-width: 700px) {
      &:not(:last-child) {
        padding-right: 2rem;
      }

      &:not(:first-child) {
        padding-left: 2rem;
      }
    }

    &:not(:last-child) {
      border-bottom: 0.1rem solid #cbcbcb;

      @media (min-width: 700px) {
        border-right: 0.1rem solid #cbcbcb;
        border-bottom: 0;
      }
    }
  }
}

.p-title {
  font-family: 'SST Condensed';
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;

  span {
    color: $backgroundBlue;
  }
}

.p-warning {
  color: $backgroundBlue;
  font-weight: 700;

  span {
    font-family: 'SST Condensed';
    font-weight: 500;
    letter-spacing: 2px;
    text-decoration: underline;
    text-transform: uppercase;
  }
}

// Overrides
.p-news.c-form__check {
  margin-left: 4.2rem;
}

.p-news .c-form__check-label {
  line-height: 1.25;
}

.c-form__check-label a {
  color: inherit;
}
</style>
